import {createElement, forwardRef} from 'react';
import {NavLink} from 'components';
import {noop, some, get, omit, kebabCase, getElementAttributes} from 'helpers';
import css from './card.module.scss';
import * as Components from './components';

const blackRectangle = `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h100v100H0z" fill="black" fill-opacity="0.65"/></svg>`;

export const Card = forwardRef((props, ref) =>
  createElement(props.navLink && !props.disabled ? NavLink : props.href ? 'a' : 'div', {
    ...build(props),
    ref,
  })
);

function build(props) {
  return {
    ...getElementAttributes(props),
    'data-id': props['data-id'] || props.id,
    to: props.navLink ? props.navLink : undefined,
    exact: props.exact,
    style: getStyle(props),
    className: css('card', omit(props, 'draggable'), props.className, {
      ['is-'+kebabCase(props.status)]: true,
      ['is-priority-'+kebabCase(props.priority)]: true,
      ['is-muted']: props.muted,
      [`is-${props.timeframe}`]: true,
      ['is-dark']: !props.onCalendar && Boolean(props.darkBackground),
      [kebabCase(props.background)]: true,
      draggable: props.draggable && props.onClick === noop,
      hasBackground: !props.onCalendar && (Boolean(props.background) || Boolean(props.darkBackground)),
      hasRightMenu: some(props.children, child => get(child, 'type.name', '').match(/RightMenu/)),
      hasCheckbox: some(props.children, child => get(child, 'type.name', '').match(/Checkbox$/)),
      hasOnClick: Boolean(props.onClick) && props.onClick !== noop,
    }),
  }
}

function getStyle({ background, darkBackground, style, onCalendar }) {
  const image = get(background || darkBackground, 'url');
  if (/^(http|data:image)/.test(image) && !onCalendar) {
    style = {
      ...style,
      backgroundImage: `url(${image})`,
      backgroundPosition: 'center',
    }
  }
  if (darkBackground && style && style.backgroundImage) {
    style = {
      ...style,
      backgroundImage: `url(data:image/svg+xml;base64,${btoa(blackRectangle)}), ${style.backgroundImage}`,
      backgroundBlendMode: 'darken, normal',
    }
  }
  return style;
}

for (const key in Components) {
  Card[key] = Components[key];
}

Card.css = css;
